import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'FormEntry';

const FormEntryApi: any = baseApi(endpoint);

export default FormEntryApi;